/**
 * Created by Pactera on 2017/4/14.
 */
import Routes from 'Routes';
import ProgressBar from 'ProgressBar';
import PopUpLoad from 'PopUpLoad';
import TicPopUp from 'TicPopUp';
import PopPwd from 'PopPwd';
// import PopDisposal from 'PopDisposal';
import bankAuthPopup from './routes/refundApply/components/BankAuthPopup';
import explainBox from './routes/applySubmit/components/Explain';
import { saveOldLocation } from './modules/actions';
import appContainer from './containers/AppContainer';
import updateDetail from './routes/updateDetail';
import endorsedApply from './routes/endorsedApply';
import selectDate from './routes/selectDate';
import ticketChanges from './routes/ticketChanges';
import applySubmit from './routes/applySubmit';
import reformProcess from './routes/reformProcess';
import addPersonMessage from './routes/addPersonMessage';
import addProductShop from './routes/addProductShop';
import faceRecognition from './routes/faceRecognition';
import certificationResults from './routes/certificationResults';
import feeQuery from './routes/feeQuery';
import changeFlight from './routes/changeFlight';
import pay from './routes/pay';
import electronicInvoice from './routes/electronicInvoice';
import coupon from './routes/coupon';
import refundCoupon from './routes/refundCoupon';
import easyLogin from './routes/easyLogin';
import refundApply from './routes/refundApply';
import wrongPurchase from './routes/wrongPurchase';
import viewProgress from './routes/viewProgress';
import discountTicketApplication from './routes/discountTicketApplication';
import facemoreQurey from './routes/facemoreQurey';
import changeRefundExplain from './routes/changeRefundExplain';
import cancelLation from './routes/cancelLation';

import { Toast } from 'antd-mobile';

export default store => ({
  path: Routes.ticket.key,
  component: appContainer,
  onChange: (prevState, nextState, replace, callback) => {
    // 切换路由，全局功能
    if (prevState.location.pathname !== nextState.location.pathname) {
      ProgressBar.clear();
      PopUpLoad.clear();
      TicPopUp.clear();
      PopPwd.clear();
      // PopDisposal.clear();
      explainBox.clear();
      bankAuthPopup.clear();
      Toast.hide();
    }
    callback();
  },
  childRoutes: [
    updateDetail(store),
    endorsedApply(store),
    refundApply(store),
    ticketChanges(store),
    applySubmit(store),
    reformProcess(store),
    addPersonMessage(store),
    addProductShop(store),
    faceRecognition(store),
    certificationResults(store),
    {
      path: Routes.ticket.child.loginFeeQuery.key,
      indexRoute: {
        onEnter: (nextState, replace) => {
          const {
            location: {
              search,
              query: { lastName, ticketNo },
            },
          } = nextState;
          if (lastName && ticketNo) {
            replace(
              `${Routes.ticket.child.feeQuery.childs.list.path}${search}`
            );
          } else {
            replace(
              `${Routes.ticket.child.feeQuery.childs.login.path}${search}`
            );
          }
        },
        onLeave(prevState) {
          store.dispatch(saveOldLocation(prevState.location));
        },
      },
    },
    feeQuery(store),
    selectDate(store),
    changeFlight(store),
    easyLogin(store),
    pay(store),
    electronicInvoice(store),
    coupon(store),
    refundCoupon(store),
    wrongPurchase(store),
    viewProgress(store),
    discountTicketApplication(store),
    facemoreQurey(store),
    changeRefundExplain(store),
    cancelLation(store),
  ],
});



// WEBPACK FOOTER //
// ./src/routes/index.js